import { render, staticRenderFns } from "./ShareManagement.vue?vue&type=template&id=c310c958&scoped=true"
import script from "./ShareManagement.vue?vue&type=script&lang=js"
export * from "./ShareManagement.vue?vue&type=script&lang=js"
import style0 from "./ShareManagement.vue?vue&type=style&index=0&id=c310c958&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c310c958",
  null
  
)

export default component.exports